import Security from "./security";

export default Security;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Security/security_universe/index.js